module.exports = __webpack_public_path__ + "img/ipad-frame-portrait.068e54d.png";